import { Component, State, h, Prop, Method, Element } from "@stencil/core";

@Component({
  tag: "lk-banner"
})
export class Banner {

  @Prop() bannerType = "green";
  @Prop() appearance: string = "";
  @Prop() opened: boolean = false;

  @State() display: boolean = false;
  
  @Element() hostElement: HTMLElement;

  hasToggleBodySlot: boolean;


  componentWillLoad() {
    if (this.opened) {
      this.display = true;
    }

    let toggleBodySlot = this.hostElement.querySelector('[slot="toggle-body"]');
    if (toggleBodySlot == null) {
      this.hasToggleBodySlot = false;
    } else {
      this.hasToggleBodySlot = toggleBodySlot.innerHTML.split("\n").join("").split(" ").join("") != "";
    }

  }

  @Method()
  async changeDisplayStatus(display: boolean) {
    this.display = display;
  }

  handleToggleButton(event) {
    event.preventDefault();
    this.display = !this.display;
  }

  renderIcon() {
    let icon;
    switch (this.bannerType) {
      case "blue":
      case "done":
      case "yes":
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12,11 v6"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <circle cx="12" cy="7.5" r="1.1" fill="currentColor"></circle>
            <circle cx="12" cy="12" r="11" stroke="currentColor" stroke-width="1.5"></circle>
          </svg>
        );
      case "green":
      case "success":
        icon =
          <svg aria-hidden="true" focusable="false" role="presentation" version="1.1" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24" height="24" width="24">
            <g transform="matrix(1,0,0,1,0,0)">
              <path d="M 12,7.5v6 "
                stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
              <path d="M 12,16.5c-0.207,0-0.375,0.168-0.375,0.375S11.793,17.25,12,17.25 s0.375-0.168,0.375-0.375S12.207,16.5,12,16.5 "
                stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
              <circle cx="12" cy="12" r="11" stroke="currentColor" fill="none" stroke-width="1.5"></circle>
            </g>
          </svg>
        break;
      case "yellow":
      case "orange":
      case "warning":
        icon =
        <svg aria-hidden="true" focusable="false" role="presentation" version="1.1" xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24" height="24" width="24">
          <g transform="matrix(1,0,0,1,0,0)">
            <path d="M 12,18.75c-0.207,0-0.375,0.168-0.375,0.375S11.793,19.5,12,19.5s0.375-0.168,0.375-0.375 S12.207,18.75,12,18.75L12,18.75 "
              stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M 12,15.75v-7.5 "
              stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M 13.621,1.76c-0.44-0.895-1.522-1.265-2.417-0.825 c-0.359,0.176-0.649,0.466-0.825,0.825L0.906,21.058c-0.371,0.754-0.06,1.665,0.694,2.036c0.209,0.103,0.439,0.156,0.672,0.156 h19.456c0.84,0.001,1.521-0.68,1.522-1.52c0-0.233-0.053-0.463-0.156-0.672L13.621,1.76z"
              stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          </g>
        </svg>
        break;
      case "pink":
      case "red":
      case "danger":
        icon =
        <svg aria-hidden="true" focusable="false" role="presentation" version="1.1" xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24" height="24" width="24">
          <g transform="matrix(1,0,0,1,0,0)">
            <path d="M 12,18.75c-0.207,0-0.375,0.168-0.375,0.375S11.793,19.5,12,19.5s0.375-0.168,0.375-0.375 S12.207,18.75,12,18.75L12,18.75 "
              stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M 12,15.75v-7.5 "
              stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M 13.621,1.76c-0.44-0.895-1.522-1.265-2.417-0.825 c-0.359,0.176-0.649,0.466-0.825,0.825L0.906,21.058c-0.371,0.754-0.06,1.665,0.694,2.036c0.209,0.103,0.439,0.156,0.672,0.156 h19.456c0.84,0.001,1.521-0.68,1.522-1.52c0-0.233-0.053-0.463-0.156-0.672L13.621,1.76z"
              stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          </g>
        </svg>
        break;
      default:
        break;
    }
    return icon;
  }

  getDisplayStatus(){
    if (this.display)
    return 'true';
    else return 'false';
  }

  render() {
    const appearance = this.appearance == 'rounded' ? 'banner--rounded' : '';

    return (
      <div class={`banner banner--${this.bannerType} ${appearance}`}>
        <div class={`container banner__content`} >
          {this.hasToggleBodySlot &&
            <button
              type="button"
              class={`banner__button`}
              onClick={event => { this.handleToggleButton(event); }}
              aria-expanded = {this.getDisplayStatus()}
              aria-label={this.display ? 'Vis mindre' : 'Vis mer'}>

              <div class="banner__button-icon" aria-hidden="true" style={{ transform: this.display ? "rotate(-180deg)" : "rotate(0deg)" }}>

                <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.299 6.3">
                  <path d="M13.513.747l4.8,6.9-4.8,6.9" transform="translate(15.296 -12.763) rotate(90)" fill="none" stroke="currentColor"
                    stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                </svg>

              </div>

            </button>
          }

          <span class={`banner__icon`} aria-hidden="true">
            {this.renderIcon()}
          </span>

          <div class="banner__text">
            <slot name="head" />
            <slot name="body" />
            <div class={`${this.display ? "banner__text--active" : "banner__text--inactive "} `}>
              <slot name="toggle-body" />
            </div>
          </div>
        </div>

      </div>
    );
  }
}
